<template>
  <div
    id="layout"
    style="visibility: visible;"
  >
    <div id="north">
      <header-info cur="2"></header-info>
    </div>
    <div
      id="center"
      style="min-height: 677px;"
    >
      <div
        id="content"
        class="content"
        style=""
      >
        <div
          class="center_content container"
          style="visibility: visible;"
        >
          <div class="box-wrap mbox clearfix">
            <div class="lBox">
              <div class="title">
                <p class="title_text">{{ formInfo.title }}</p>
              </div>
              <div class="detail-base clearfix">
                <p class="detail-item">
                  学院：{{ formInfo.academy ? formInfo.academy.title : '--' }}</p>
                <p class="detail-item">对应专业大类：{{
                    formInfo.subject ? formInfo.subject.subject_category.title : '--'
                  }}</p>
                <p class="detail-item">对应专业：{{ formInfo.subject ? formInfo.subject.title : '--' }}</p>
                <p class="detail-item">负责人教师：{{ formInfo.master_name ? formInfo.master_name : '--' }}</p>
                <p class="detail-item">实验时长（分钟）：{{ formInfo.duration ? formInfo.duration : '--' }}</p>
                <p class="detail-item">实验最大并发数：{{ formInfo.concurrence ? formInfo.concurrence : '--' }}</p>
                <p class="detail-item">有效链接：{{ formInfo.url ? formInfo.url : '--' }}</p>
                <div class="detail-intro"><span class="label">实验简介：</span>
                  <p>{{ formInfo.brief ? formInfo.brief : '' }}</p>
                </div>
              </div>
            </div>
            <div class="rBox">
              <div class="title">
                <p class="title_text">{{ formInfo.title }}</p>
                <div class="title-btns">
                  <router-link
                    :to="'/www/experiment?id=' + formInfo.id"
                    class="preview"
                  >预览</router-link>
                </div>
              </div>
              <div class="imgCover">
                <img
                  :src="formInfo.logo"
                  :onerror="$store.state.defaultImg"
                  width="130"
                  height="76"
                >
              </div>
            </div>
          </div>
          <div class="box-wrap info-box">
            <div class="menu-box">
              <ul class="menu-list clearfix">
                <li
                  v-for="item in menuList"
                  @click="MenuClick(item)"
                  :key="item.id"
                  :class="{'on' : onClick == item.id}"
                >
                  <a href="javascript:;">{{item.title}}</a>
                </li>
              </ul>
            </div>
            <div
              class="part"
              v-if="onClick==1"
            >
              <div class="title">
                <p
                  class="title-text"
                  id="title-text"
                >选课学生</p>
                <div class="title-btns">
                  <a
                    href="javascript:;"
                    class="add"
                    id="addBtn"
                    @click="getSutdentinfo(),showWindow.member = true"
                  >添加学生</a>
                </div>
              </div>
              <form
                id="searchSection"
                onsubmit="return false;"
                class="m-t-md"
              >
                <input
                  type="text"
                  v-model="electiveInfo.userprofile_name"
                  placeholder="姓名"
                  class="s-input separate"
                  maxlength="25"
                >
                <input
                  type="text"
                  v-model="electiveInfo.userprofile_username"
                  placeholder="账号"
                  class="s-input separate"
                  maxlength="25"
                >
                <input
                  type="text"
                  v-model="electiveInfo.userprofile_s_no"
                  placeholder="学号"
                  class="s-input separate"
                  maxlength="25"
                >
                <select
                  class="s-select separate"
                  @change="searchMajor(electiveInfo.academy_id)"
                  v-model="electiveInfo.academy_id"
                >
                  <option value="">选择院系</option>
                  <option
                    :value="item.id"
                    v-for="item in academyData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
                <select
                  class="s-select separate"
                  v-model="electiveInfo.major_id"
                >
                  <option value="">选择专业</option>
                  <option
                    :value="item.id"
                    v-for="item in majorData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
                <input
                  type="button"
                  class="s-btn"
                  @click="electivePageCallback(1)"
                  value="查询"
                  id="searchBtn"
                >
              </form>
              <div
                class="list"
                id="teamList1"
              >
                <table v-if="ElectiveData.length">
                  <tbody>
                    <tr class="l_header">
                      <th width="35px"><a
                          href="javascript:;"
                          class="a-link"
                          @click="ckAll"
                        >全选</a></th>
                      <th>账号</th>
                      <th>姓名</th>
                      <th>性别</th>
                      <th>学院</th>
                      <th>专业</th>
                      <th>学号</th>
                      <th>加入实验时间</th>
                      <th>分组名称</th>
                      <th
                        class="action"
                        style="width:180px"
                      >操作</th>
                    </tr>
                    <tr
                      class="item"
                      v-for="(item, index) in ElectiveData"
                      :key="index"
                    >
                      <td><input
                          type="checkbox"
                          :value="item.id"
                          v-model="ckUser"
                        ></td>
                      <td>{{item.userprofile.username}}</td>
                      <td>{{item.userprofile.name}}</td>
                      <td>{{item.userprofile.gender==1?'男':'女'}}</td>
                      <td>{{item.experiment.academy.title}}</td>
                      <td>{{item.userprofile.major?getMajor(item.userprofile.major):'-'}}</td>
                      <td>{{item.userprofile.s_no?item.userprofile.s_no:'-'}}</td>
                      <td>{{item.created.substr(0, 10)}}</td>
                      <td>{{item.student_group_id?item.student_group.title:' - - '}}</td>
                      <td class="action">
                        <a
                          class="edit"
                          style="cursor: pointer"
                          @click="addgroupindex=1,addGroupwindows(item.id)"
                        >分配分组</a>
                        <a
                          v-if="item.student_group_id"
                          class="delete"
                          style="cursor: pointer"
                          @click="delElective(item.id)"
                        >移除分组</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="noitems"
                  v-else
                >没有数据</div>
              </div>
              <pagination
                :cur='electivePageInfo.page'
                :all='electivePageInfo.all'
                :totalData="electivePageInfo.totalData"
                :callback="electivePageCallback"
              ></pagination>
              <button
                class="batchBtn"
                id="batchBtn"
                @click="addgroupindex=2,addGroupwindows()"
              >添加到分组</button>
            </div>
            <div
              class="part"
              v-if="onClick==2"
            >
              <div class="title">
                <p
                  class="title-text"
                  id="title-text"
                >分组管理</p>
                <div class="title-btns">
                  <a
                    href="javascript:;"
                    class="add"
                    id="addBtn"
                    @click="showAddWindow"
                  >添加分组</a>
                </div>
              </div>
              <form
                id="searchSection"
                onsubmit="return false;"
                class="m-t-md hide"
              >
                <input
                  type="text"
                  placeholder="姓名"
                  class="s-input separate"
                >
                <input
                  type="text"
                  placeholder="账号"
                  class="s-input separate"
                >
                <input
                  type="text"
                  placeholder="学号"
                  class="s-input separate"
                >
                <select class="s-select separate">
                  <option value="">选择院系</option>
                  <option
                    :value="item.id"
                    v-for="item in academyData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
                <select class="s-select separate">
                  <option value="">选择专业</option>
                </select>
                <input
                  type="button"
                  class="s-btn"
                  value="查询"
                  @click="GroupPageCallback(1)"
                  id="searchBtn"
                >
              </form>
              <div
                class="list"
                id="list"
              >
                <table v-if="GroupData.length">
                  <tbody>
                    <tr class="l_header">
                      <th>分组名称</th>
                      <th>负责人教师</th>
                      <th>学生人数</th>
                      <th
                        class="action"
                        style="width:180px"
                      >操作</th>
                    </tr>
                    <tr
                      class="item"
                      v-for="(item, index) in GroupData"
                      :key="index"
                    >
                      <td>{{item.title}}</td>
                      <td>{{item.teacher.name}}</td>
                      <td>{{item.select_count}}</td>
                      <td class="action">
                        <a
                          v-if="item.select_count==0"
                          class="edit"
                          style="cursor: pointer"
                          @click="editGroup(item.id)"
                        >编辑</a>
                        <a
                          class="delete"
                          style="cursor: pointer"
                          @click="delGroup(item.id)"
                        >删除</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="noitems"
                  v-else
                >没有数据</div>
              </div>
              <pagination
                :cur='GroupPageInfo.page'
                :all='GroupPageInfo.all'
                :totalData="GroupPageInfo.totalData"
                :callback="GroupPageCallback"
              ></pagination>
            </div>
            <div
              class="part"
              v-if="onClick==3"
            >
              <div class="title">
                <p
                  class="title-text"
                  id="title-text"
                >申请学习学生</p>
              </div>
              <form
                id="searchSection"
                onsubmit="return false;"
                class="m-t-md"
              >
                <input
                  type="text"
                  v-model="studyInfo.userprofile_name"
                  placeholder="姓名"
                  class="s-input separate"
                >
                <input
                  type="text"
                  v-model="studyInfo.userprofile_username"
                  placeholder="账号"
                  class="s-input separate"
                >
                <input
                  type="text"
                  v-model="studyInfo.userprofile_s_no"
                  placeholder="学号"
                  class="s-input separate"
                >
                <select
                  class="s-select separate"
                  @change="searchMajor(studyInfo.academy_id)"
                  v-model="studyInfo.academy_id"
                >
                  <option value="">选择院系</option>
                  <option
                    :value="item.id"
                    v-for="item in academyData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
                <select
                  class="s-select separate"
                  v-model="studyInfo.major_id"
                >
                  <option value="">选择专业</option>
                  <option
                    :value="item.id"
                    v-for="item in majorData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
                <input
                  type="button"
                  class="s-btn"
                  @click="studyPageCallback(1)"
                  value="查询"
                  id="searchBtn"
                >
              </form>
              <div
                class="list"
                id="teamList1"
              >
                <table v-if="studyData.length">
                  <tbody>
                    <tr class="l_header">
                      <th>账号</th>
                      <th>姓名</th>
                      <th>性别</th>
                      <th>学院</th>
                      <th>专业</th>
                      <th>学号</th>
                      <th>加入实验时间</th>
                      <th
                        class="action"
                        style="width:180px"
                      >操作</th>
                    </tr>
                    <tr
                      class="item"
                      v-for="(item, index) in studyData"
                      :key="index"
                    >
                      <td>{{item.userprofile.username}}</td>
                      <td>{{item.userprofile.name}}</td>
                      <td>{{item.userprofile.gender==1?'男':item.userprofile.gender==0?'女':'-'}}</td>
                      <td>{{item.userprofile.academy?FunRetrieval(item.userprofile.academy):'-'}}</td>
                      <td>{{item.userprofile.major?getMajor(item.userprofile.major):'-'}}</td>
                      <td>{{item.userprofile.s_no?item.userprofile.s_no:'-'}}</td>
                      <td>{{item.created.substr(0, 10)}}</td>
                      <td class="action">
                        <span
                          class="text-green"
                          v-if="item.audit_status==1"
                        >已同意</span>
                        <span
                          class="edit"
                          v-else
                          @click="Agrenter(item.id)"
                        >同意</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="noitems"
                  v-else
                >没有数据</div>
              </div>
              <pagination
                :cur='studyPageInfo.page'
                :all='studyPageInfo.all'
                :totalData="studyPageInfo.totalData"
                :callback="studyPageCallback"
              ></pagination>
            </div>
          </div>
          <div
            class="form_overlay"
            :style="classShowGroupWindow"
          >
            <div class="form_overlay_bg"></div>
            <div class="form_panel">
              <div class="form_title">分配分组</div>
              <div class="form_content">
                <div class="form_content">
                  <form id="groupForm">
                    <div class="item">
                      <span class="label"><i class="require">*</i>分组</span>
                      <select v-model="electiveform.student_group_id">
                        <option value="">选择分组</option>
                        <option
                          :value="item.id"
                          v-for="item in GroupData"
                          :key="item.id"
                        >{{item.title}}</option>
                      </select>
                    </div>
                  </form>
                </div>
              </div>
              <div class="form_control">
                <a
                  href="javascript:;"
                  class="button close"
                  id="form_close"
                  @click="hideGroupWindow"
                >取消</a>
                <a
                  href="javascript:;"
                  v-if="addgroupindex==1"
                  class="button"
                  id="form_submit"
                  @click="addGroup"
                >提交</a>
                <a
                  href="javascript:;"
                  v-if="addgroupindex==2"
                  class="button"
                  id="form_submit"
                  @click="addBatchGroup"
                >提交</a>
              </div>
            </div>
          </div>
          <div
            id="c-panel"
            :style="showWindow.member ? 'display: block' : ''"
          >
            <div id="c-panel-bg"></div>
            <div class="c-content">
              <form
                id="search"
                onsubmit="return false;"
              >
                <input
                  type="text"
                  class="s-text"
                  v-model="studentInfo.name"
                  placeholder="姓名"
                >
                <input
                  type="text"
                  class="s-text"
                  v-model="studentInfo.username"
                  placeholder="用户名"
                >
                <input
                  type="submit"
                  class="s-btn1"
                  @click="studentPageCallback(1)"
                  value="查询"
                >
                <span
                  class="close-cpanel"
                  @click="showWindow.member = false"
                ></span>
              </form>
              <div id="uList">
                <table v-if="studentData.length">
                  <tbody>
                    <tr class="l_header">
                      <th>用户名</th>
                      <th>姓名</th>
                      <th>性别</th>
                      <th>所属学院</th>
                      <th
                        class="action"
                        style="width:150px"
                      >操作</th>
                    </tr>
                    <tr
                      class="item"
                      v-for="(item, index) in studentData"
                      :key="index"
                    >
                      <td>{{item.username}}</td>
                      <td>{{item.name}}</td>
                      <td>{{item.gender==1?'男':'女'}}</td>
                      <td>{{formInfo.academy.title}}</td>
                      <td class="action">
                        <a
                          class="a-button"
                          v-if="isExist(item.id)"
                          @click="addElective(item.id)"
                        >选择</a>
                        <a
                          class=""
                          v-else
                        >已选择</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="noitems"
                  v-else
                >没有数据</div>
              </div>
              <pagination
                :cur='studentPageInfo.page'
                :all='studentPageInfo.all'
                :totalData="studentPageInfo.totalData"
                :callback="studentPageCallback"
              ></pagination>
            </div>
          </div>
          <div
            class="form_overlay"
            :style="classShowAddWindow"
          >
            <div class="form_overlay_bg"></div>
            <div class="form_panel">
              <div class="form_title">添加/编辑分组</div>
              <div class="form_content">
                <div class="form_content">
                  <form id="groupForm">
                    <div class="item">
                      <span class="label"><i class="require">*</i>名称</span>
                      <input
                        v-model="groupformInfo.title"
                        type="text"
                        autocomplete="off"
                        maxlength="25"
                      >
                    </div>
                    <div class="item">
                      <span class="label"><i class="require">*</i>注意</span>
                      <div class="txtbox">
                        <div class="accord">
                          <p>分组一旦创建成功且分配学生后，分组将不再允许修改名称和删除，请谨慎操作！</p>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <span class="label"><i class="require">*</i>教师</span>
                      <select v-model="groupformInfo.teacher_id">
                        <option value="">选择负责人教师</option>
                        <option
                          :value="item.id"
                          v-for="item in studentData"
                          :key="item.id"
                        >{{item.name}}</option>
                      </select>
                    </div>
                  </form>
                </div>
              </div>
              <div class="form_control">
                <a
                  href="javascript:;"
                  class="button close"
                  id="form_close"
                  @click="hideAddWindow"
                >取消</a>
                <a
                  href="javascript:;"
                  class="button"
                  id="form_submit"
                  @click="SaveGroup"
                >提交</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="south">
      <footer-info></footer-info>
      <div id="footer"></div>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
import Pagination from '../../../components/Pager'
export default {
  // 可用组件的哈希表
  components: {
    HeaderInfo,
    FooterInfo,
    Pagination
  },
  // 接收传值
  props: {},
  // 数据对象
  data () {
    return {
      onClick: 1,
      ckUser: [],
      addgroupindex: 1,
      formInfo: {
        id: 0,
        academy_id: 0,
        academy: null,
        subject_id: 0,
        subject: null,
        master_id: 0,
        master_name: '',
        title: '',

        url: '',
        isTeacherCheck: 0,
        exp_level: 0,
        duration: '',
        concurrence: '',
        brief: '',
        claim: '',
        logo: ''
      },
      showWindow: {
        member: false
      },
      // 选课学生
      electiveInfo: {
        page: 1,
        size: 10,
        is_select: 1,
        userprofile_username: '',
        userprofile_name: '',
        userprofile_s_no: '',
        academy_id: '',
        major_id: '',
        experiment_id: ''
      },
      electiveform: {
        id: '',
        student_group_id: ''
      },
      ElectiveData: [],
      ElectiveCount: 0,
      // 学生列表
      studentInfo: {
        page: 1,
        size: 10,
        role: 3,
        name: '',
        username: '',
        academy_id: ''
      },
      studentData: [],
      studentCount: 0,
      // 分组
      GroupInfo: {
        page: 1,
        size: 10,
        experiment_id: ''
      },
      GroupData: [],
      GroupCount: 0,
      groupformInfo: {
        id: 0,
        experiment_id: '',
        teacher_id: '',
        title: ''
      },
      // 申请学习学生
      studyInfo: {
        page: 1,
        size: 10,
        is_select: 0,
        expJoinType: 0,
        userprofile_username: '',
        userprofile_name: '',
        userprofile_s_no: '',
        academy_id: '',
        major_id: '',
        experiment_id: ''
      },
      studyData: [],
      studyCount: 0,
      classShowAddWindow: {},
      classShowGroupWindow: {},
      menuList: [
        { id: 1, title: '选课学生' },
        { id: 2, title: '分组管理' },
        { id: 3, title: '申请学习学生' }
      ],
      params: {
        id: 0
      },
      academyData: [], // 学院列表
      majorData: [],
      majorDataAll: []
    }
  },
  // 事件处理器
  methods: {
    // 全选
    ckAll() {
      if (this.ckUser.length === this.ElectiveData.length) {
        this.ckUser = []
      } else {
        for (let i = 0; i < this.ElectiveData.length; i++) {
          this.ckUser.push(this.ElectiveData[i].id)
        }
      }
    },
    FunRetrieval(id) {
      var title = ''
      this.academyData.forEach(element => {
        if (element.id === id) {
          title = element.title
        }
      })
      return title
    },
    // 选课学生列表分页
    electivePageCallback(data) {
      this.electiveInfo.page = data
      this.getExperimentSelect()
    },
    // 添加学生列表分页
    studentPageCallback(data) {
      this.studentInfo.page = data
      this.getSutdentinfo()
    },
    // 分组分页
    GroupPageCallback(data) {
      this.GroupInfo.page = data
      this.getExperimentGroup()
    },
    // 申请学习学生列表分页
    studyPageCallback(data) {
      this.studyInfo.page = data
      this.getExperimentStudent()
    },
    async getInfo() {
      const url = '/experiment/' + this.params.id + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取学生成员
    async getSutdentinfo(type) {
      if (type === 2) {
        this.studentInfo.role = 2
      }
      this.studentInfo.academy_id = this.formInfo.academy.id
      await this.$http.get('/userprofile/', {
        params: this.studentInfo
      }).then((data) => {
        this.studentData = data.results
        this.studentCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取学院
    async searchAcademy() {
      await this.$http.get('/academy/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        this.academyData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    async searchMajor(id, type) {
      this.electiveInfo.major_id = ''
      await this.$http.get('/major/', {
        params: {
          page: 1,
          size: 10000,
          academy_id: id,
          status: 1
        }
      }).then((data) => {
        this.majorData = data.results
        if (type === 1) {
          this.majorDataAll = data.results
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getMajor(id) {
      var mojorname = ''
      this.majorDataAll.forEach(element => {
        if (element.id === id) {
          mojorname = element.title
        }
      })
      return mojorname
    },
    isExist(id) {
      var isExist = true
      this.ElectiveData.forEach(element => {
        if (element.userprofile.id === id) {
          isExist = false
        }
      })
      return isExist
    },
    async addElective(id) {
      // type=1 新增成员
      var formInfo = {}
      formInfo = {
        experiment_id: this.$route.query.id,
        userprofile_id: id,
        is_select: 1,
        expJoinType: 0
      }
      await this.$http.post('/experimentstudent/', formInfo).then((data) => {
        if (data.id) {
          this.$layer.msg('添加成功！')
          this.showWindow.member = false
          this.getExperimentSelect()
        } else {
          this.$layer.msg('添加失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('添加失败！')
      })
    },
    async delElective(id) {
      const url = '/experimentstudent/' + id + '/'
      await this.$http.put(url, {
        student_group_id: null
      }).then((data) => {
        if (data.id) {
          this.$layer.msg('移除成功！')
          this.getExperimentSelect()
        } else {
          this.$layer.msg('移除失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('移除失败！')
      })
    },
    async addGroup() {
      if (this.electiveform.student_group_id === '') {
        this.$layer.msg('请选择分组！')
        return false
      }
      const url = '/experimentstudent/' + this.electiveform.id + '/'
      await this.$http.put(url, {
        student_group_id: this.electiveform.student_group_id
      }).then((data) => {
        if (data.id) {
          this.$layer.msg('添加成功！')
          this.hideGroupWindow()
          this.getExperimentSelect()
        } else {
          this.$layer.msg('添加失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('添加失败！')
      })
    },
    async addBatchGroup() {
      if (this.electiveform.student_group_id === '') {
        this.$layer.msg('请选择分组！')
        return false
      }
      if (this.ckUser.length === 0) {
        this.$layer.msg('请选择！')
        return false
      }
      this.ckUser.forEach(async element => {
        const url = '/experimentstudent/' + element + '/'
        await this.$http.put(url, {
          student_group_id: this.electiveform.student_group_id
        }).then((data) => {
          if (data.id) {
            this.$layer.msg('添加成功！')
            this.hideGroupWindow()
            this.getExperimentSelect()
            this.ckUser = []
          } else {
            this.$layer.msg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('添加失败！')
        })
      })
    },
    // 添加分组
    async SaveGroup() {
      if (this.groupformInfo.id) {
        const url = '/experimentstudentgroup/' + this.groupformInfo.id + '/'
        await this.$http.put(url, this.groupformInfo).then((data) => {
          if (data.id) {
            this.$layer.msg('修改成功！')
            this.classShowAddWindow = {}
            this.getExperimentGroup()
          } else {
            this.$layer.msg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('修改失败！')
        })
      } else {
        this.groupformInfo.experiment_id = this.$route.query.id
        await this.$http.post('/experimentstudentgroup/', this.groupformInfo).then((data) => {
          if (data.id) {
            this.$layer.msg('添加成功！')
            this.classShowAddWindow = {}
            this.getExperimentGroup()
          } else {
            this.$layer.msg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('添加失败！')
        })
      }
    },
    // 编辑分组
    async editGroup(id) {
      const url = '/experimentstudentgroup/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.groupformInfo = {
          id: id,
          title: data.title,
          teacher_id: data.teacher_id
        }
        this.showAddWindow()
      }).catch((error) => {
        console.log(error)
        this.$parent.$parent.showMsg('数据获取失败！')
      })
    },
    async delGroup(id) {
      const url = '/experimentstudentgroup/' + id + '/'
      await this.$http.put(url, {
        isdel: 1
      }).then((data) => {
        this.$layer.msg('删除成功！')
        this.getExperimentGroup()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('删除失败！')
      })
    },
    async Agrenter(id) {
      const url = '/experimentstudent/' + id + '/'
      await this.$http.put(url, {
        audit_status: 1
      }).then((data) => {
        this.getExperimentStudent()
        this.$layer.msg('操作成功！')
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('操作失败！')
      })
    },
    getUrlKey(name) {
      const url = window.location.href
      const dzUrl = url.split('#')[0]
      if (dzUrl.split('?').length <= 1) {
        return ''
      }
      const csArr = dzUrl.split('?')[1].split('&')
      const cs = {}
      for (let i = 0; i < csArr.length; i++) {
        cs[csArr[i].split('=')[0]] = csArr[i].split('=')[1]
      }
      return cs[name]
    },
    MenuClick(e) {
      this.onClick = e.id
      if (e.id === 1) {
        this.getExperimentSelect()
      } else if (e.id === 2) {
        this.getExperimentGroup()
      } else if (e.id === 3) {
        this.getExperimentStudent()
      }
      this.electiveInfo.page = 1
      this.GroupInfo.page = 1
      this.studyInfo.page = 1
    },
    showAddWindow() {
      this.getSutdentinfo(2)
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    hideAddWindow() {
      this.classShowAddWindow = {}
      this.groupformInfo = {
        id: 0,
        experiment_id: '',
        teacher_id: '',
        title: ''
      }
    },
    addGroupwindows(id) {
      this.electiveform.id = id
      this.classShowGroupWindow = {
        visibility: 'visible'
      }
      this.getExperimentGroup()
    },
    hideGroupWindow() {
      this.electiveform.student_group_id = ''
      this.classShowGroupWindow = {}
    },
    // 获取选课学生列表
    async getExperimentSelect() {
      this.electiveInfo.experiment_id = this.$route.query.id
      await this.$http.get('/experimentstudent/', {
        params: this.electiveInfo
      }).then((data) => {
        this.ElectiveData = data.results
        this.ElectiveCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取分组列表
    async getExperimentGroup() {
      this.GroupInfo.experiment_id = this.$route.query.id
      await this.$http.get('/experimentstudentgroup/', {
        params: this.GroupInfo
      }).then((data) => {
        this.GroupData = data.results
        this.GroupCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取申请个学生列表
    async getExperimentStudent() {
      this.studyInfo.experiment_id = this.$route.query.id
      await this.$http.get('/experimentstudent/', {
        params: this.studyInfo
      }).then((data) => {
        this.studyData = data.results
        this.studyCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  // 生命周期-实例创建完成后调用
  created () { },
  // 生命周期-实例挂载后调用
  mounted () {
    this.params.id = this.getUrlKey('id')
    this.getInfo()
    this.getExperimentSelect()
    this.searchAcademy()
    this.searchMajor('', 1)
  },
  // 生命周期-实例销毁离开后调用
  destroyed () { },
  // 计算属性监听
  computed: {
    studentPageInfo() {
      return {
        page: this.studentInfo.page,
        all: Math.ceil(this.studentCount / this.studentInfo.size),
        totalData: this.studentCount
      }
    },
    electivePageInfo() {
      return {
        page: this.electiveInfo.page,
        all: Math.ceil(this.ElectiveCount / this.electiveInfo.size),
        totalData: this.ElectiveCount
      }
    },
    GroupPageInfo() {
      return {
        page: this.GroupInfo.page,
        all: Math.ceil(this.GroupCount / this.GroupInfo.size),
        totalData: this.GroupCount
      }
    },
    studyPageInfo() {
      return {
        page: this.studyInfo.page,
        all: Math.ceil(this.studyCount / this.studyInfo.size),
        totalData: this.studyCount
      }
    }
  },
  // 自定义的侦听器
  watch: {}
}
</script>
<style scoped src="../../../assets/css/project-detail.css"></style>
<style scoped src="../../../assets/css/table.css"></style>
<style scoped src="../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../assets/css/project-manage.css"></style>
<style lang="less" scoped>
#searchSection .s-btn {
  border: 1px solid #12BDAA;
  background: #73D6CA;
  height: 34px;
  line-height: 34px;
  text-align: center;
  color: #fff;
  /* float: left; */
  padding: 0px 12px;
  cursor: pointer;
  border-radius: 2px;
  vertical-align: middle;
  display: inline-block;
  margin-bottom: 10px;
}
#batchBtn,
#printBtn,
#choosBtn {
  background-color: #73D6CA;
  color: #fff;
  cursor: pointer;
  float: left;
  border-radius: 3px;
  border: 0;
  margin-bottom: 0;
  margin-top: 30px;
  padding: 0 10px;
  line-height: 32px;
  height: 32px;
  margin-right: 10px;
  font-size: 12px;
}
</style>
